/**
 * @desc Imagry layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import summer40cm2014 from "./summer40cm2014";
import summer10m2014Muni from "./summer10m2014Muni";
import winter50cm2009BCGov from "./winter50cm2009BCGov";
import summer7_5cm2018 from "./summer7_5cm2018";
import summer10cm2018 from "./summer10cm2018";
import summerDrone2019 from "./summerDrone2019";

export default {
  modules: {
    // Order these how it's wanted in the menu
    summer10cm2018,
    summer7_5cm2018,
    summerDrone2019,
    summer10m2014Muni,
    summer40cm2014,
    winter50cm2009BCGov
  }
};
